/** Canonical Tebox UI typeface (Google Fonts in `apps/web/index.html` and `apps/booking/index.html`). */
export const PLATFORM_UI_FONT_NAME = 'Inter' as const;

/** @deprecated Use {@link PLATFORM_UI_FONT_NAME} */
export const GOOGLE_SANS_FLEX_FONT_NAME = PLATFORM_UI_FONT_NAME;

export type FontFamily = typeof PLATFORM_UI_FONT_NAME;

export const APP_FONT_FAMILY_CSS = `'${PLATFORM_UI_FONT_NAME}', sans-serif`;

/** Legacy persisted booking/admin font names — normalized to {@link PLATFORM_UI_FONT_NAME}. */
const LEGACY_FONT_ALIASES: Record<string, typeof PLATFORM_UI_FONT_NAME> = {
  Raleway: PLATFORM_UI_FONT_NAME,
  'Google Sans Flex': PLATFORM_UI_FONT_NAME,
  'Stack Sans Text': PLATFORM_UI_FONT_NAME,
  'Host Grotesk': PLATFORM_UI_FONT_NAME,
  TWKLausanne: PLATFORM_UI_FONT_NAME,
  'TWK Lausanne': PLATFORM_UI_FONT_NAME,
  Castoro: PLATFORM_UI_FONT_NAME,
  Lexend: PLATFORM_UI_FONT_NAME,
};

/**
 * Normalize any stored or detected font label to the platform UI font.
 */
export function normalizeToPlatformUiFontName(
  fontFamily: string | undefined | null,
): typeof PLATFORM_UI_FONT_NAME {
  const t = typeof fontFamily === 'string' ? fontFamily.trim() : '';
  if (!t || t === PLATFORM_UI_FONT_NAME) {
    return PLATFORM_UI_FONT_NAME;
  }
  return LEGACY_FONT_ALIASES[t] ?? PLATFORM_UI_FONT_NAME;
}

/** @deprecated Use {@link normalizeToPlatformUiFontName} */
export function normalizeToGoogleSansFontName(
  fontFamily: string | undefined | null,
): typeof PLATFORM_UI_FONT_NAME {
  return normalizeToPlatformUiFontName(fontFamily);
}

/** CSS `font-family` stack for all Tebox UI surfaces. */
export function getPlatformUiFontFamilyCSS(): string {
  return APP_FONT_FAMILY_CSS;
}

/** @deprecated Use {@link getPlatformUiFontFamilyCSS} */
export function getGoogleSansFontFamilyCSS(): string {
  return APP_FONT_FAMILY_CSS;
}

export const getFontFamily = (): FontFamily => PLATFORM_UI_FONT_NAME;

export const getFontFamilyCSS = (): string => APP_FONT_FAMILY_CSS;

export const applyFontFamily = (): void => {
  document.documentElement.style.setProperty('--app-font-family', APP_FONT_FAMILY_CSS);
  window.dispatchEvent(
    new CustomEvent('fontFamilyChanged', { detail: { fontFamily: PLATFORM_UI_FONT_NAME } }),
  );
};

if (typeof window !== 'undefined') {
  document.documentElement.style.setProperty('--app-font-family', APP_FONT_FAMILY_CSS);
}
